import CampaignCreationBrandSelection from 'Components/campaigns/create-edit/BrandSelection';
import React, { useState } from 'react'
import { UserBrand } from 'types/users';

const CreateCampaignAIBrief = () => {
    const [selectedBrand, setSelectedBrand] = useState<UserBrand | null>(null);


    if (!selectedBrand) {
        return <CampaignCreationBrandSelection value={selectedBrand} onChange={setSelectedBrand} />
    }

    return (
        <>
            {selectedBrand && (
                null // TODO: Add campaign brief AI component here
            )}

        </>
    )
}

export default CreateCampaignAIBrief